import { requestApi } from './Api';

export const interimApi = async (url, params, navigate) => {
  return await requestApi({ url, params, navigate, returnRaw: true });
};
